<template>
  <v-footer
    padless
    v-if="applicationLoaded"
    id="footerArea"
    class="d-flex flex-column justify-center"
    :class="routeName"
  >
    <template v-if="isDark">
      <div class="hakkaContainer">
        <div
          class="footerContainer justify-md-space-between align-center pt-md-2 pb-md-6 pb-5 px-md-10 px-1"
          :class="footerContentClass"
        >
          <div
            class="d-flex flex-column align-center flex-md-row justify-md-space-between"
          >
            <div class="footerLogo mb-3" v-if="!isWebviewMode">
              <router-link
                :to="{ name: 'home' }"
                class="black--text text-decoration-none"
              >
                <v-img
                  contain
                  :src="require('@/assets/hakka-logo.svg')"
                ></v-img>
              </router-link>
            </div>
            <div class="footerOptionsBox mb-5 mb-md-7 mt-md-3" v-if="!isWebviewMode">
              <ul class="d-flex justify-md-start justify-center">
                <li>
                  <router-link :to="{ name: 'post' }" class="footerOptions">
                    最新消息
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{ name: 'service', params: { type: 'about' } }"
                    class="footerOptions"
                  >
                    公開資訊
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{ name: 'service', params: { type: 'audience' } }"
                    class="footerOptions"
                  >
                    公眾服務
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'custom-service',
                      params: { type: 'audience' },
                    }"
                    class="footerOptions"
                  >
                    線上客服
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

          <div
            class="third-party d-flex flex-column flex-md-row-reverse justify-md-space-between mt-6 mt-md-0"
          >
            <!-- app store / google play -->
            <div class="">
              <p class="d-md-none white--text">APP下載</p>
              <div class="mb-4 mb-md-0 pl-md-2">
                <!-- <h5>APP 下載</h5> -->
                <div class="d-sm-flex align-center">
                  <div class="d-flex justify-start">
                    <a
                      href="https://apps.apple.com/us/app/%E5%AE%A2%E5%AE%B6%E9%9B%BB%E8%A6%96%E5%8F%B0/id1574129092"
                      target="_blank"
                    >
                      <v-img
                        max-width="128"
                        :height="iconSize"
                        class="mr-2 mr-md-3"
                        contain
                        :src="require('@/assets/img/app-store-badge.png')"
                      ></v-img>
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.pts.hakkatv&hl=en_US&gl=US"
                      target="_blank"
                    >
                      <v-img
                        max-width="142"
                        :height="iconSize"
                        class=""
                        contain
                        :src="require('@/assets/img/google-play-badge.png')"
                      ></v-img>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!isWebviewMode" class="mt-10 mt-md-0 px-md-2 mx-md-1">
              <p class="d-md-none white--text">社群媒體</p>
              <div class="mb-5 mb-md-0">
                <div class="d-flex">
                  <template v-for="(platform, index) in platforms">
                    <v-hover v-slot="{ hover }" :key="platform.value">
                      <a
                        class="social-icon-area"
                        :class="{
                          'mr-1': index != platforms.length - 1,
                          'on-Hover': hover,
                        }"
                        target="_blank"
                        :href="platform.link"
                        transition="fade-transition"
                      >
                        <v-img
                          class="social-icon"
                          :width="iconSize"
                          :height="iconSize"
                          contain
                          :src="platform.photos[0]"
                        ></v-img>
                        <v-img
                          class="social-icon-hover"
                          :width="iconSize"
                          :height="iconSize"
                          contain
                          :src="platform.photos[1]"
                        ></v-img>
                      </a>
                    </v-hover>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="footerContainer mt-2 mt-md-10">
            <v-card-text class="white--text px-3">
              <div class="text-center">{{ copyright }}</div>
              <div class="reCAPTCHACopyrightB text-center mt-4">
                本站採用 reCAPTCHA 保護機制
                <a href="https://policies.google.com/privacy" target="_blank">
                  隱私權
                </a>
                &
                <a href="https://policies.google.com/terms" target="_blank">
                  條款
                </a>
              </div>
            </v-card-text>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div
        class="d-flex justify-md-space-between flex-md-row flex-column align-center pt-md-2 pb-5 mt-8 my-md-6 footerLightWrapper"
        :class="footerContentClass"
      >
        <div
          class="d-flex justify-center flex-md-row flex-column align-center"
          v-if="!isWebviewMode"
        >
          <div class="footerLogo">
            <router-link
              :to="{ name: 'home' }"
              class="black--text text-decoration-none"
            >
              <v-img
                width="150"
                height="36"
                contain
                :src="require('@/assets/hakka-logo.svg')"
              ></v-img>
            </router-link>
          </div>
          <div class="footerOptionsBox ml-md-5 mt-md-0 mt-5">
            <ul class="d-flex justify-md-start justify-center">
              <li>
                <router-link :to="{ name: 'post' }" class="footerOptions">
                  最新消息
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'service', params: { type: 'about' } }"
                  class="footerOptions"
                >
                  公開資料
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'service', params: { type: 'audience' } }"
                  class="footerOptions"
                >
                  公眾服務
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'custom-service', params: { type: 'audience' } }"
                  class="footerOptions"
                >
                  線上客服
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <!-- app store / google play -->
        <div class="d-flex mt-10 mt-md-0">
          <a
            href="https://play.google.com/store/apps/details?id=com.pts.hakkatv&hl=en_US&gl=US"
            target="_blank"
          >
            <v-img
              width="135"
              max-width="135"
              height="40"
              class="mr-md-2 mr-4"
              contain
              :src="require('@/assets/img/google-play-badge.svg')"
            ></v-img>
          </a>
          <a
            href="https://apps.apple.com/us/app/%E5%AE%A2%E5%AE%B6%E9%9B%BB%E8%A6%96%E5%8F%B0/id1574129092"
            target="_blank"
          >
            <v-img
              width="110"
              max-width="110"
              height="40"
              class="mr-md-2"
              contain
              :src="require('@/assets/img/app-store-badge.svg')"
            ></v-img>
          </a>
        </div>
      </div>

      <div class="d-flex align-center footerLightCopy">
        <div
          class="d-flex align-center justify-sm-space-between flex-sm-row flex-column-reverse footerLightCopyWrapper"
        >
          <div>
            <v-card-text class="white--text text-left pb-0">
              <pre>{{ copyright }}</pre>
            </v-card-text>
            <v-card-text class="reCAPTCHACopyrightL text-center pt-0">
              <span
                >本站採用 reCAPTCHA 保護機制
                <a href="https://policies.google.com/privacy" target="_blank"
                  >隱私權</a
                >
                &
                <a href="https://policies.google.com/terms" target="_blank"
                  >條款</a
                >
              </span>
            </v-card-text>
          </div>
          <div class="d-flex justify-start mt-sm-0 mt-5">
            <a target="_blank" href="https://www.facebook.com/hakkatv/">
              <v-img
                width="30"
                max-width="30"
                height="30"
                class="mr-2"
                contain
                :src="require('@/assets/img/social-icon-facebook.svg')"
              ></v-img>
            </a>
            <!-- <v-img
              width="30"
              max-width="30"
              height="30"
              class="mr-2"
              contain
              :src="require('@/assets/img/social-icon-instagram.svg')"
            ></v-img> -->
            <a target="_blank" href="https://www.youtube.com/user/hakkatv">
              <v-img
                width="30"
                max-width="30"
                height="30"
                class="mr-2"
                contain
                :src="require('@/assets/img/social-icon-youtube.svg')"
              ></v-img>
            </a>
          </div>
        </div>
      </div>
    </template>
  </v-footer>
</template>

<script lang="babel" type="text/babel">
export default {
  data() {
    return {
      platforms: [
        {
          label: "Facebook",
          value: "facebook",
          link: "https://www.facebook.com/hakkatv/",
          photos: [
            require("@/assets/icon/facebook-white-thin.svg"),
            require("@/assets/icon/facebook-green-thin.svg"),
          ],
        },
        {
          label: "Instagram",
          value: "instagram",
          link: "https://www.instagram.com/hakkatv_2003/",
          photos: [
            require("@/assets/icon/instagram-white.svg"),
            require("@/assets/icon/instagram-green.svg"),
          ],
        },
        {
          label: "Youtube",
          value: "youtube",
          link: "https://www.youtube.com/user/hakkatv",
          photos: [
            require("@/assets/icon/youtube-white.svg"),
            require("@/assets/icon/youtube-green.svg"),
          ],
        },
      ],
      iconSize: 46

    };
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    isWebviewMode() {
      return this.$store.getters["base/isWebviewMode"];
    },
    isDark() {
      return this.$store.getters["base/isDark"];
    },
    footerContentClass() {
      if (!this.isMobile) return null;
      return ["flex-column", "flex-md-row"];
    },
    isMobile() {
      return this.$store.getters["base/isMobile"];
    },
    applicationLoaded() {
      return this.$store.getters["base/applicationLoaded"];
    },
    copyright() {
      const year = this.$helper.moment().format("YYYY");
      return this.$helper.render(this.site.copyright, { year });
    },
    site() {
      return this.$store.getters["base/site"];
    },
  },
};
</script>

<style lang="sass" type="text/sass" scoped></style>
